'use strict';
var currentY = 0;

function click(e) {
    var readmore = e.target.closest('a');
    if (readmore && readmore.dataset.readmore && /more|less/.test(readmore.dataset.readmore)) {
        var readmoreParent = readmore.parentElement;
        e.preventDefault();
        e.stopPropagation();

        var more = readmore.dataset.readmore === "more"
        readmoreParent.hidden = true;
        if(more){
          currentY = window.pageYOffset;
        }
        readmoreParent[(more ? 'nextElementSibling' : 'previousElementSibling')].hidden = false
        var wrapper = more ? readmoreParent.previousElementSibling : readmoreParent.previousElementSibling.previousElementSibling
        if(wrapper.firstElementChild.dataset.readmoreHide){
          wrapper.firstElementChild.classList.toggle('hide')
        }
        wrapper.firstElementChild.dataset.readmore && wrapper.firstElementChild.classList[(more ? 'remove' : 'add')]('ellipsis')
        var readMores = wrapper.querySelectorAll('[data-readmore=item]');
        Array.from(readMores).forEach(function(itm){
            itm.classList.toggle('hide', !more)
            scrollTo(document.body, currentY, 100);
        })

    }
}

document.addEventListener('click', click);
